export function toUri (path) {
  return path.replace(window.SITE_BASE, '').replace(/^\/+/g, '')
}

export function toApiUri (path) {
  const uri = toUri(path)
  const params = getKirbyParams(uri)
  let apiuri
  if (uri === '') {
    apiuri = 'home.json'
  } else if (params.params) {
    // Note: content rep params that start with page fail on localhost
    apiuri = params.uri + '.json/' + params.params
  } else {
    apiuri = uri + '.json'
  }
  return apiuri
}

export function getKirbyParams (uri) {
  const segments = uri.split('/')
  const separator = ':'
  
  let uriSegment = []
  let paramsSegment = []
  
  segments.forEach(segment => {
    const kv = segment.split(separator)
    if (kv.length === 2) {
      paramsSegment.push({
        key: kv[0],
        value: kv[1]
      })
    } else {
      uriSegment.push(kv[0])
    }
  })

  return {
    uri: uriSegment.join('/'),
    params: paramsSegment.map(p => `${p.key}${separator}${p.value}`).join('/') || false,
    data: paramsSegment
  }
}

export function stitchKirbyParams (params) {
  return params.map(p => `${p.key}${separator}${p.value}`).join('/') || false
}

export function toAbsolutePath (path) {
  return `${window.SITE_BASE}/${path}`
}

export function isHomePage (path) {
  return toUri(path) === ''
}

export function isLandingPage (path) {
  const uri = toUri(path)
  return uri.startsWith('exhibitions') || uri.startsWith('events')
}

export function createNode (html) {
  return new DOMParser().parseFromString(html, "text/html").body.firstChild
}

export function isEqual (a, b) {
  try {
    return JSON.stringify(a) === JSON.stringify(b)
  } catch (e) {
    return false
  }
}

export function setCssVariable (key, value) {
  const root = document.querySelector(':root')
  root.style.setProperty(key, value)
}

export function getCssVariable (key, asInt) {
  const root = document.querySelector(':root')
  const rs = getComputedStyle(root)
  const val = rs.getPropertyValue(key)
  return asInt ? parseInt(val) : val
}

export const scrollIntoViewWithOffset = ($element, offset, options) => {
  window.scrollTo(Object.assign({
    top:
      $element.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  }, options || {}))
}

export const isHover = window.matchMedia('(hover: hover)')
export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

export const accent = '#f00'

export const calmFlyTo = (coordinates, map) => {
  let options = {
    center: coordinates
  }

  // only zoom in when zoomed out
  if (map.getZoom() < 15) {
    options.zoom = 15
  }

  // disable curve when zoomed in
  if (map.getZoom() >= 15 && map.getBounds().contains(coordinates)) {
    options.curve = 0
  }

  map.flyTo(options)
}

/**
 * This function horizonatally shifts overlapping points
 * to avoid the need for spiderification.
 */
export const shiftOverlappingPoints = (geojson) => {
  const groupByCoordinates = geojson?.features.reduce((a, feature) => {
    const coordinates = feature.geometry.coordinates.join(',')
    if (!a[coordinates]) {
      a[coordinates] = []
    }
    a[coordinates].push(feature)
    return a
  }, {})

  const overlappingPointGroups = Object.values(groupByCoordinates).filter(groups => (groups.length > 1))

  overlappingPointGroups.forEach(group => {
    group.forEach((point, i) => {
      const coordinates = point.geometry.coordinates
      
      // Modify the point in the actual geojson
      // geojson.features[point.id].geometry.coordinates[0] = coordinates[0] + (0.00005 * i)
      geojson.features[point.id].geometry.coordinates[0] = coordinates[0] + (0.0001 * i)
    })
  })

  return geojson
}